import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/app.css";
import "./styles/fixes.css";
import { App } from "./App";
import { watchStaleChunks } from "./lib/staleChunk";
import { watchViewport } from "./lib/viewport";

// Keept Runner is light only: the root carries data-theme="light" (index.html) and the panel's own tokens.
document.documentElement.dataset.theme = "light";
// After a deploy, a part of the old build that is gone reloads the tab once (lib/staleChunk.ts).
watchStaleChunks();
// On a phone the full-screen surfaces follow the visible area above the on-screen keyboard (lib/viewport.ts).
watchViewport();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
